import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Mail, LogOut, ArrowRight } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

/**
 * Hub post-connexion : l'utilisateur choisit le type de document à créer.
 */
const DocumentHub: React.FC = () => {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const firstName = (user?.fullName || '').trim().split(/\s+/)[0] || '';

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <header className="bg-white border-b border-slate-200 sticky top-0 z-20">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                        <img src="/flashcv.png" alt="FlashCv" className="w-8 h-8 object-contain" />
                        <span className="font-bold text-slate-900">FlashCV</span>
                    </div>
                    <button
                        type="button"
                        onClick={logout}
                        className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
                    >
                        <LogOut size={16} />
                        <span className="hidden sm:inline">Déconnexion</span>
                    </button>
                </div>
            </header>

            <main className="flex-1 max-w-5xl w-full mx-auto px-4 sm:px-6 py-12">
                <div className="mb-10">
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
                        Bienvenue{firstName ? ` ${firstName}` : ''}
                    </h1>
                    <p className="text-slate-500 font-medium mt-2">
                        Perfectionnez votre candidature grâce à nos outils et démarquez-vous des
                        autres candidats.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <button
                        type="button"
                        onClick={() => navigate('/choix-modele')}
                        className="group text-left bg-white rounded-2xl border-2 border-transparent shadow-sm hover:shadow-lg hover:border-indigo-200 transition-all p-8 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                    >
                        <div className="w-14 h-14 rounded-xl bg-indigo-50 flex items-center justify-center mb-5 group-hover:bg-indigo-100 transition-colors">
                            <FileText className="w-7 h-7 text-indigo-600" />
                        </div>
                        <h2 className="text-xl font-bold text-slate-900 mb-2">Mes CV</h2>
                        <p className="text-slate-500 text-sm mb-6">
                            Modèles professionnels, dont des designs adaptés au marché ivoirien
                        </p>
                        <span className="inline-flex items-center gap-1.5 text-sm font-bold text-indigo-600 group-hover:gap-2.5 transition-all">
                            Explorer <ArrowRight size={16} />
                        </span>
                    </button>

                    <button
                        type="button"
                        onClick={() => navigate('/creer-lettre')}
                        className="group text-left bg-white rounded-2xl border-2 border-transparent shadow-sm hover:shadow-lg hover:border-teal-200 transition-all p-8 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
                    >
                        <div className="w-14 h-14 rounded-xl bg-teal-50 flex items-center justify-center mb-5 group-hover:bg-teal-100 transition-colors">
                            <Mail className="w-7 h-7 text-teal-600" />
                        </div>
                        <h2 className="text-xl font-bold text-slate-900 mb-2">
                            Mes lettres de motivation
                        </h2>
                        <p className="text-slate-500 text-sm mb-6">
                            Parcours guidé + rédaction par IA selon votre secteur, puis édition libre
                        </p>
                        <span className="inline-flex items-center gap-1.5 text-sm font-bold text-teal-700 group-hover:gap-2.5 transition-all">
                            Commencer <ArrowRight size={16} />
                        </span>
                    </button>
                </div>
            </main>
        </div>
    );
};

export default DocumentHub;
